import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, INTEGER, DATETIME, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Account from '@/plugins/sdk/resources/Account'
import Carrier from '@/plugins/sdk/resources/Carrier'

export default class extends Resource {
  static name = 'account_carriersetting'

  static get fields () {
    return {
      id: new UUID(),
      charge_account: new STRING(),
      con_prefix: new STRING(),
      con_min: new INTEGER(),
      con_max: new INTEGER(),
      con_next_id: new INTEGER(),
      manifest_prefix: new STRING(),
      manifest_min: new INTEGER(),
      manifest_max: new INTEGER(),
      manifest_nextid: new INTEGER(),
      edi_siteid: new STRING(),
      edi_sysid: new STRING(),
      carrier_active: new BOOLEAN(),
      carrier_is_customers: new BOOLEAN(),
      always_third_party: new BOOLEAN(),
      active_in_shipper: new BOOLEAN(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      account: new ITEM(Account),
      carrier: new ITEM(Carrier),
      quote_externally: new BOOLEAN()
    }
  }

  static get sortables () {
    return [
      { field: 'charge_account', label: 'Charge Account' },
      { field: 'con_prefix', label: 'CON Prefix' },
      { field: 'manifest_prefix', label: 'Manifest Prefix' },
      { field: 'edi_siteid', label: 'EDI Site ID' },
      { field: 'edi_sysid', label: 'EDI Sys ID' },
      { field: 'carrier_active', label: 'Carrier Active' },
      { field: 'carrier_is_customers', label: 'Carrier is Customers' },
      { field: 'always_third_party', label: 'Always Third Party' },
      { field: 'active_in_shipper', label: 'Active in Shipper' },
      { field: 'created_at', label: 'Created Date' },
      { field: 'updated_at', label: 'Updated Date' }
    ]
  }
}
